import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { NAV, SITE } from '../../mock';
import { Menu, X } from 'lucide-react';

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-navy-950/70 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3 select-none">
          <img
            src="/images/logo.png"
            alt="Nishit Thakkar"
            className="h-10 w-auto md:h-11 rounded-lg object-contain"
          />
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-[17px] tracking-tight text-white">
              {SITE.brandTop} {SITE.brandBottom}
            </span>
            <span className="text-[9px] tracking-[0.22em] uppercase text-amber-300/80">
              Manifestation · Implementation
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n, i) => {
            const cls = `text-sm transition-colors ${
              i === 0 ? 'text-amber-300' : 'text-neutral-300 hover:text-white'
            }`;
            return n.href.startsWith('/') ? (
              <Link key={n.label} to={n.href} className={cls}>
                {n.label}
              </Link>
            ) : (
              <a key={n.label} href={n.href} className={cls}>
                {n.label}
              </a>
            );
          })}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/apply"
            className="inline-flex items-center justify-center rounded-full px-5 py-2.5 text-sm font-medium text-neutral-900 bg-gradient-to-b from-amber-200 to-amber-400 shadow-[0_4px_20px_-4px_rgba(251,191,36,0.45)] hover:shadow-[0_8px_28px_-6px_rgba(251,191,36,0.65)] hover:-translate-y-[1px] transition-all duration-200"
          >
            Apply Now
          </Link>
        </div>

        <button
          aria-label="Open menu"
          className="md:hidden text-neutral-200 p-2"
          onClick={() => setOpen((s) => !s)}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-navy-950/95">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) =>
              n.href.startsWith('/') ? (
                <Link
                  key={n.label}
                  to={n.href}
                  onClick={() => setOpen(false)}
                  className="text-sm text-neutral-200 py-2"
                >
                  {n.label}
                </Link>
              ) : (
                <a
                  key={n.label}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="text-sm text-neutral-200 py-2"
                >
                  {n.label}
                </a>
              )
            )}
            <Link
              to="/apply"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-full px-5 py-2.5 text-sm font-medium text-neutral-900 bg-gradient-to-b from-amber-200 to-amber-400"
            >
              Apply Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
